/* eslint-disable */

import FullPagePopupLayout from '../Popups/FullPagePopupLayout'

const PaymentStatusModal = ({
  isOpen = false,
  onClose,
  onContinue,
  onRetry,
  status = 'inprogress',
  loading = false,
  paymentData,
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'success':
        return {
          severity: 'success',
          title: 'Payment Successful',
          description: 'Your payment has been completed successfully.',
          statusText: 'Completed',
          statusTone: 'success',
          infoText:
            'Your payment has been processed successfully. Allocation will be done in 2 days based on funds.',
          showRetry: false,
          showComplete: false,
        }
      case 'failure':
        return {
          severity: 'failure',
          title: 'Payment Failed',
          description: 'Your payment could not be processed.',
          statusText: 'Failed',
          statusTone: 'error',
          infoText:
            'Your payment could not be processed. Please check your payment details and try again.',
          showRetry: true,
          showComplete: false,
        }
      default:
        return {
          severity: 'info',
          title: 'Payment Processing',
          description:
            paymentData?.paymentMode?.includes('Cheque') ||
              paymentData?.paymentMode?.includes('OTM') ? (
              'Your order is being processed.'
            ) : (
              <>
                Awaiting confirmation from your bank.
                <br />
                Payments may take 1-2 hrs to reflect.
              </>
            ),
          statusText: 'In Progress',
          statusTone: 'warning',
          infoText: paymentData?.paymentMode?.includes('OTM') ? (
            'Your money will be debited automatically within the next 2 working days.'
          ) : paymentData?.paymentMode?.includes('Cheque') ? (
            'Your Relationship Manager will stay in touch with you.'
          ) : (
            <>
              Your money is safe.
              <br />
              <span>Please retry if your payment was unsuccessful.</span>
            </>
          ),
          showRetry:
            paymentData?.paymentMode?.includes('Cheque') ||
            paymentData?.paymentMode?.includes('OTM')
              ? false
              : true,
          showComplete: true,
        }
    }
  }

  const config = getStatusConfig()
  const actionCount =
    (config.showRetry ? 1 : 0) +
    (config.showComplete ? 1 : 0) +
    (status === 'success' ? 1 : 0) +
    (status === 'failure' ? 1 : 0)

  const handleAction = (action) => {
    if (typeof action === 'string') {
      window.location.href = action
    } else if (typeof action === 'function') {
      action()
    }
  }

  const handleRetry = () => {
    handleAction(onRetry)
  }

  const handleComplete = () => {
    handleAction(onContinue)
  }

  const handleClose = () => {
    handleAction(onClose)
  }

  if (!isOpen) return null

  return (
    <FullPagePopupLayout
      isOpen={isOpen}
      onClose={handleClose}
      severity={config.severity}
      title={config.title}
      message={config.description}
      bodyClassName='fabits-payment-status-body'
      actionsClassName={actionCount === 1 ? 'fabits-global-popup-actions-single' : undefined}
      actions={
        <>
          {config.showRetry && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-secondary'
              onClick={handleRetry}
              disabled={loading}
            >
              {loading ? 'Retrying...' : 'Retry Payment'}
            </button>
          )}

          {config.showComplete && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={handleComplete}
            >
              {paymentData?.paymentMode?.includes('Cheque')
                ? 'Order Completed'
                : 'Payment Completed'}
            </button>
          )}

          {status === 'success' && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-primary'
              onClick={() => handleAction(onContinue)}
            >
              Done
            </button>
          )}

          {status === 'failure' && (
            <button
              type='button'
              className='fabits-global-popup-button fabits-global-popup-button-secondary'
              onClick={handleClose}
            >
              Close
            </button>
          )}
        </>
      }
    >
      <div className='fabits-payment-status-panel'>
        <h4 className='fabits-payment-status-section-title'>Investment Details</h4>

        <div className='fabits-payment-status-detail-list'>
          <div className='fabits-payment-status-detail-row'>
            <span className='fabits-payment-status-label'>Investment Amount</span>
            <span className='fabits-payment-status-value'>₹ {paymentData?.amount}</span>
          </div>

          <div className='fabits-payment-status-detail-row'>
            <span className='fabits-payment-status-label'>Status</span>
            <span className='fabits-payment-status-state' data-tone={config.statusTone}>
              {config.statusText}
            </span>
          </div>

          <div className='fabits-payment-status-detail-row'>
            <span className='fabits-payment-status-label'>Payment Mode</span>
            <span className='fabits-payment-status-value'>{paymentData?.paymentMode}</span>
          </div>
        </div>
      </div>

      <div className='fabits-payment-info-box'>
        <h5 className='fabits-payment-info-title'>More Information</h5>
        <p className='fabits-payment-info-text'>{config.infoText}</p>
      </div>
    </FullPagePopupLayout>
  )
}

export default PaymentStatusModal
